// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__KDm8S","validationTips":"StatementDescriptor_validationTips__vMcvJ"};